export const darkTheme = {
	body: {
		background: 'black',
		color: 'white'
	},
	button: {
		background: '#7700ff',
		color: 'white'
	},
	colors: {
		black: '#000e1a',
		white: '#fff',
		blue: '#007ce0',
		navy: '#004175'
	}
};
